import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './index.module.css';

const ActionLabel = /*#__PURE__*/function () {
  const ActionLabel = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);

    return /*#__PURE__*/React.createElement("span", _extends({
      className: cx(styles.root, className),
      ref: ref
    }, rest), children);
  });
  ActionLabel.displayName = 'ActionLabel';
  ActionLabel.identifier = ActionLabel.displayName; // used in docs website

  ActionLabel.propTypes = {
    /** Contents displayed within the ActionLabel. */
    children: PropTypes.node,

    /** Extend classNames. */
    className: PropTypes.string
  };
  return ActionLabel;
}();

export default ActionLabel;